import React from 'react';

import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput
} from '@mui/material';
import type { FieldError } from 'react-hook-form';

import { errorColor, gray100, gray80, gray90 } from '../../constants/Colors';

type OutlinedInputProps = React.ComponentProps<typeof OutlinedInput>;

type Props = OutlinedInputProps & {
  error?: boolean;
  helperText?: string | FieldError | undefined;
  labelText?: string;
};

const CustomHalfTextfield = React.forwardRef(
  (props: Props, ref): React.ReactElement => {
    const { error, helperText, labelText, ...rest } = props;

    function inputBorderColor(): string {
      return error ? errorColor : gray80;
    }

    function errorColorOrGray100(): string {
      return error ? errorColor : gray100;
    }

    function labelColor(): string {
      return error ? errorColor : gray90;
    }

    const styles = {
      input: {
        height: '40px',
        width: '272px',
        '& .css-yjsfm1': {
          maxWidth: '100%'
        },
        '&.MuiInputBase-formControl .MuiOutlinedInput-input.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input::-webkit-input-placeholder':
          {
            color: gray90,
            opacity: '1!important'
          },
        '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
          borderColor: inputBorderColor()
        },
        '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
          {
            borderColor: errorColorOrGray100(),
            borderWidth: '1px'
          },
        '&.MuiOutlinedInput-root:hover': {
          borderColor: errorColorOrGray100(),
          borderWidth: '1px'
        },
        '@media screen and (max-width: 960px)': {
          width: '100%'
        }
      },
      smallLabel: {
        color: labelColor(),
        fontSize: '12px',
        transform: 'translate(14px, -7px)',
        '&.Mui-focused': {
          color: errorColorOrGray100()
        }
      }
    };

    const textfieldHelper = (): string => {
      return String(helperText);
    };

    return (
      <FormControl sx={{ width: '100%' }}>
        <InputLabel sx={styles.smallLabel}>{labelText}</InputLabel>
        <OutlinedInput
          {...rest}
          autoComplete="off"
          error={error}
          label={labelText}
          ref={ref}
          sx={styles.input}
          value={rest.value ?? ''}
        />
        <FormHelperText error={error} sx={{ m: '3px 0 0' }}>
          {error && textfieldHelper()}
        </FormHelperText>
      </FormControl>
    );
  }
);
CustomHalfTextfield.displayName = 'CustomHalfTextfield';
export default CustomHalfTextfield;
